import React from "react";
import { Col } from "react-bootstrap";

import styles from "./styles.module.scss";

interface TableHeaderProps {
  col: number;
  value: string;
  onClick: () => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({ col, value, onClick }) => {
  if (!value) {
    return <Col md={col} />;
  }
  // !sortOrd && onClick('asc')
  return (
    <Col md={col}>
      <div className={styles.header} onClick={() => onClick()}>
        <p className={styles.label}>{value}</p>
      </div>
    </Col>
  );
};

export default TableHeader;
